const changeEducation = {
  state: {
    changeEducation: {}
  },
  mutations: {
    SET_CHANGEeDUCATION (state, changeEducation) {
      state.changeEducation = changeEducation
    }
  }
}

export default changeEducation



// WEBPACK FOOTER //
// ./src/store/modules/changeEducation.js